import CONF from '@/Config.js';
import axios from 'axios';
import Constant from '@/constant';

export default {
    saveFile: function(file)
    {
        var formData = new FormData();
        formData.append("file", file)

        return axios({
            method: 'post',
            url: CONF.SAVE_FILE,
            data: formData
        })
    },
    tempSaveDiabetes: function(files, body, token)
    {
        var data = new FormData();
        
        for( var i = 0; i < files.premedical_files.length; i++)
        {
            data.append('premedical_files', files.premedical_files[i]);
        }
        data.append('signature_file', files.signature_file)
        data.append('delegation_docs_file', files.delegation_docs_file)
        data.append('id_card_file', files.id_card_file) 
        data.append('body', JSON.stringify(body));

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.TEMP_SAVE_DIABETES,
            data: data
        })
    },
    fetchTempSaveDiabetes: function(name, registration_number, token)
    {
        var data = {
            name: name,
            registration_number: registration_number,
            barocare_client_id: process.env.BAROCARE_CLINET_ID
        }

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_TEMP_SAVE_DIABETES,
            data: data
        })
    },
    saveFirstDiabets: function(request_data, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_FIRST_DIABETES,
            data: request_data
        })
    },
    saveRevisitDiabetes: function(request_data, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_REVISIT_DIABETES,
            data: request_data
        })
    },
    checkDiabetesExists: function(name, registration_number, token)
    {
        var data = {
            barocare_client_id: process.env.BAROCARE_CLINET_ID,
            name: name,
            registration_number: registration_number
        }
        
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.CHECK_DIABETES_EXISTS,
            data: data
        })
    },
    signinDiabetesUser: function(kakao_access_token)
    {
        return axios({
            method: 'get',
            headers: {
                'kakao-access-token': kakao_access_token
            },
            url: CONF.SIGNIN_DIABETES_USER
        })
    },
    // signinAgreement: function(agreement_service, agreement_personal_info, agreement_marketing, token)
    // {
    //     var data = {
    //         agreement_service: agreement_service,
    //         agreement_personal_info: agreement_personal_info,
    //         agreement_marketing: agreement_marketing
    //     }

    //     return axios({
    //         method: 'post',
    //         headers: {
    //             'diabetes-access-token': token
    //         },
    //         url: CONF.SIGNIN_AGREEMENT,
    //         data: data
    //     })
    // },
    fetchDiabetesUserProfiles: function(token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: `${CONF.FETCH_DIABETES_USER_PROFILES}?barocare_client_id=${process.env.BAROCARE_CLINET_ID}`
        })
    },
    updateDiabetesUserCard: function(request_data, token)
    {
        return axios({
            method: 'patch',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.UPDATE_DIABETES_USER_CARD,
            data: request_data
        })
    },
    fetchDiabetesSettlement: function(profile_id, token)
    {
        let url = `${CONF.FETCH_DIABETES_SETTLEMENT}?barocare_client_id=${process.env.BAROCARE_CLINET_ID}`;
        if(profile_id !== null)
        {
            url += `&profile_id=${profile_id}`;
        }       

        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchDiabetesHistory: function(profile_id, token)
    {
        let url = `${CONF.FETCH_DIABETES_HISTORY}?barocare_client_id=${process.env.BAROCARE_CLINET_ID}`;
        if(profile_id !== null)
        {
            url += `&profile_id=${profile_id}`;
        }       

        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchDiabetesDocument: function(reception_numbers, token)
    {
        let url = `${CONF.FETCH_DIABETES_DOCUMENT}?barocare_client_id=${process.env.BAROCARE_CLINET_ID}`;
        
        reception_numbers.forEach(element => {
            url += `&reception_numbers=${element}`;
        });   
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchDiabetesVocPage: function(pNo, size, sort)
    {
        return axios({
            method: 'get',
            url: CONF.FETCH_DIABETES_VOC_PAGE.replace("${pNo}", pNo).replace("${size}", size).replace("${sort}", sort)
        })
    },
    addDiabetesVoc: function(vocDiabetes, token)
    {
        // 작성자 정보(닉네임, 연락처)는 서버가 카카오 토큰으로 확인한다
        return axios({
            method: 'post',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            url: CONF.ADD_DIABETES_VOC,
            data: {
                contents: vocDiabetes.contents,
                yearCount: Number(vocDiabetes.yearCount)
            }
        })
    },
    updateDiabetesVoc: function(vocDiabetes, token)
    {
        return axios({
            method: 'put',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            url: CONF.UPDATE_DIABETES_VOC,
            data: {
                id: vocDiabetes.id
            }
        })
    },
    updateDiabetesUserDelivery: function(address, detailAddress, zipCode, addressNickname, addressDescription, profileId, token)
    {
        var data = {
            address: address,
            detail_address: detailAddress,
            zip_code: zipCode,
            address_nickname: addressNickname,
            address_description: addressDescription
        }

        return axios({
            method: 'put',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.UPDATE_DIABETES_USER_DELIVERY.replace("${profile_id}", profileId),
            data: data
        })
    },
    // v2
    signinKakao: function(kakao_access_token)
    {
        return axios({
            method: 'get',
            headers: {
                'kakao-access-token': kakao_access_token
            },
            url: CONF.SIGNIN_KAKAO
        })
    },
    signinAgreement: function(agreement_service, agreement_personal_info, agreement_marketing, token)
    {
        var data = {
            agreement_service: agreement_service,
            agreement_personal_info: agreement_personal_info,
            agreement_marketing: agreement_marketing
        }

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SIGNIN_AGREEMENT,
            data: data
        })
    },
    fetchProfiles: function(token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_PROFILES
        })
    },
    fetchExpectedDate: function(token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_EXPECTED_DATE
        })
    },
    addDraftProfile: function(draftProfile, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.ADD_DRAFT_PROFILE,
            data: draftProfile
        })
    },
    saveDelegateWithAddition: function(delegateWithAddition, profile_id, token)
    {
        var data = new FormData();

        data.append('signature_file', delegateWithAddition.signature_file)
        data.append('delegation_docs_file', delegateWithAddition.delegation_docs_file)
        data.append('id_card_file', delegateWithAddition.id_card_file) 

        data.append('agreement_delegate', delegateWithAddition.agreement_delegate);
        data.append('agreement_personal_info', delegateWithAddition.agreement_personal_info);
        data.append('agreement_personal_identification_info', delegateWithAddition.agreement_personal_identification_info);
        data.append('started_at', delegateWithAddition.started_at);
        data.append('expired_at', delegateWithAddition.expired_at);
        data.append('writer_type', delegateWithAddition.writer_type);
        data.append('writer_name', delegateWithAddition.writer_name);
        data.append('writer_birth', delegateWithAddition.writer_birth);
        data.append('writer_phone_number', delegateWithAddition.writer_phone_number);
        data.append('writer_relationship', delegateWithAddition.writer_relationship);
        data.append('writer_relationship_description', delegateWithAddition.writer_relationship_description);
        data.append('additional_info', JSON.stringify(delegateWithAddition.additional_info));

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_DELEGATE_WITH_ADDITION.replace("${profile_id}", profile_id),
            data: data
        })
    },
    saveDelegateFalse: function(profile_id, token)
    {
        var data = new FormData();
        data.append('agreement_delegate', false);     

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_DELEGATE_WITH_ADDITION.replace("${profile_id}", profile_id),
            data: data
        })
    },
    saveCard: function(cardInfo, profile_id, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_CARD.replace("${profile_id}", profile_id),
            data: cardInfo
        })
    },
    registerProfile: function(profile_id, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.REGISTER_PROFILE.replace("${profile_id}", profile_id),
        })
    },
    fetchProfile: function(profile_id, token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_PROFILE.replace("${profile_id}", profile_id),
        })
    },
    updateProfile: function(phoneNumber, profile_id, token)
    {
        var data = {
            phone_number: phoneNumber
        }

        return axios({
            method: 'patch',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.UPDATE_PROFILE.replace("${profile_id}", profile_id),
            data: data
        })
    },
    updateCard: function(cardInfo, profile_id, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.UPDATE_CARD.replace("${profile_id}", profile_id),
            data: cardInfo
        })
    },
    deleteCard: function(profile_id, token)
    {
        return axios({
            method: 'delete',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.DELETE_CARD.replace("${profile_id}", profile_id)
        })
    },
    updateDelivery: function(delivery, profile_id, token)
    {
        return axios({
            method: 'patch',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.UPDATE_DELIVERY.replace("${profile_id}", profile_id),
            data: delivery
        })
    },
    saveDelegate: function(delegateWithAddition, profile_id, token)
    {
        var data = new FormData();
        

        data.append('signature_file', delegateWithAddition.signature_file)
        data.append('delegation_docs_file', delegateWithAddition.delegation_docs_file)
        data.append('id_card_file', delegateWithAddition.id_card_file) 

        data.append('agreement_delegate', delegateWithAddition.agreement_delegate);
        data.append('agreement_personal_info', delegateWithAddition.agreement_personal_info);
        data.append('agreement_personal_identification_info', delegateWithAddition.agreement_personal_identification_info);
        data.append('started_at', delegateWithAddition.started_at);
        data.append('expired_at', delegateWithAddition.expired_at);
        data.append('writer_type', delegateWithAddition.writer_type);
        data.append('writer_name', delegateWithAddition.writer_name);
        data.append('writer_birth', delegateWithAddition.writer_birth);
        data.append('writer_phone_number', delegateWithAddition.writer_phone_number);
        data.append('writer_relationship', delegateWithAddition.writer_relationship);
        data.append('writer_relationship_description', delegateWithAddition.writer_relationship_description);

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_DELEGATE.replace("${profile_id}", profile_id),
            data: data
        })
    },
    saveDelegateAddition: function(additionInfo, profile_id, token)
    {
        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.SAVE_DELEGATE_ADDTION.replace("${profile_id}", profile_id),
            data: additionInfo
        })
    },
    fetchUsage: function(profile_id, token)
    {
        let url = `${CONF.FETCH_USAGE}`;
        if(profile_id !== null)
        {
            url += `?profile_id=${profile_id}`;
        }       

        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchDocuments: function(reception_numbers, token)
    {
        let url = `${CONF.FETCH_DOCUMENTS}`;
        
        reception_numbers.forEach((element, index) => {
            url += `${index === 0 ? '?' : '&'}reception_numbers=${element}`;
        });  
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchYearTax: function(profile_id, token)
    {
        let url = `${CONF.FETCH_YEAR_TAX}`;
        if(profile_id !== null)
        {
            url += `?profile_id=${profile_id}`;
        }       

        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: url
        })
    },
    fetchInviteCode: function(token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_INVITE_CODE
        })
    },
    applyInviteCode: function(code, token)
    {
        var data = {
            referral_code: code
        }

        return axios({
            method: 'post',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.APPLY_INVITE_CODE,
            data: data
        })
    },
    fetchInviteFriends: function(token)
    {
        return axios({
            method: 'get',
            headers: {
                'diabetes-access-token': token
            },
            url: CONF.FETCH_INVITE_FRIENDS
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/soldoc.js